import clsx from 'clsx';
import { BotIcon, UserRoundIcon } from 'lucide-react';
import { WisdomTranscriptMessage } from '../../../../api/api-client';
import { formatTime } from '../../../utils/format';

const getHumanFriendlyParticipant = (participant: 'BOT' | 'CUSTOMER') => {
  return participant === 'BOT' ? 'Agent' : 'Customer';
};

const ParticipantIcon = (props: { participant: 'BOT' | 'CUSTOMER' }) => {
  if (props.participant === 'BOT') {
    return <BotIcon className='size-4' />;
  }
  return <UserRoundIcon className='size-4' />;
};

export const WisdomMessageItem = (props: { message: WisdomTranscriptMessage; index: number }) => {
  const { message } = props;
  const messageText = message.value.text.value === '' ? '...' : message.value.text.value;

  return (
    <div key={props.index} className={clsx('bg-white rounded-xl', 'z-10 mx-auto', 'w-xl')}>
      <div className={clsx('flex flex-col gap-1.5 px-3 py-2.5 rounded-xl', 'bg-neutral-100')}>
        <div className='flex justify-between items-center w-full'>
          <div className='flex items-center gap-1 text-neutral-950'>
            <span className='flex items-center text-neutral-950'>
              <ParticipantIcon participant={message.participant} />
            </span>
            <span className='font-medium text-xs'>{getHumanFriendlyParticipant(message.participant)}</span>
          </div>
          <div className='flex items-center gap-4'>
            <span className='text-xs text-neutral-500 tabular-nums font-mono'>{message.messageId}</span>
            <span className='text-xs text-neutral-500'>{formatTime(message.timestamp)}</span>
          </div>
        </div>
        <div className='text-sm whitespace-pre-wrap text-neutral-950'>{messageText}</div>
      </div>
    </div>
  );
};
